import { autoinject } from 'aurelia-framework';

@autoinject
export class AddUserDialog {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}